/* eslint-disable @typescript-eslint/no-unused-vars */
import { LoadingButton } from '@mui/lab';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generateSerialNumbers } from 'src/api/stoApi';

interface Props {
  assetId: string;
  open: boolean;
  handleClose: () => void;
  triggerRefresh: () => void;
}

export const AutogenerateDialog: FC<Props> = ({ assetId, open, triggerRefresh, handleClose }) => {
  const { t } = useTranslation();
  const [dialogState, setDialogState] = useState<'init' | 'error' | 'success'>('init');
  const [error, setError] = useState<string>('');
  const [isLoading, setLoading] = useState(false);
  const handleCloseAndReset = () => {
    handleClose();
    setDialogState('init');
    setError('');
  };

  return (
    <Dialog open={open} onClose={handleCloseAndReset}>
      {dialogState === 'init' && (
        <>
          <DialogTitle>{t('dashboard.assets.dialog.autogenerateSerialNumbers.title')}</DialogTitle>
          <DialogContent>
            <Typography>{t('dashboard.assets.dialog.autogenerateSerialNumbers.body')}</Typography>
          </DialogContent>
          <DialogActions>
            <Button color="inherit" onClick={handleCloseAndReset}>
              {t('dashboard.assets.dialog.copy.cancel')}
            </Button>
            <LoadingButton
              loading={isLoading}
              variant="contained"
              disableElevation
              color="primary"
              onClick={async () => {
                setLoading(true);
                try {
                  const changeStatus = await generateSerialNumbers(assetId);
                  if (changeStatus.data.status === 200) {
                    setDialogState('success');
                    triggerRefresh();
                  } else {
                    setDialogState('error');
                    setError(changeStatus.data.message);
                  }
                } catch (error: any) {
                  setDialogState('error');
                } finally {
                  setLoading(false);
                }
              }}
            >
              {t('dashboard.assets.dialog.autogenerateSerialNumbers.confirm')}
            </LoadingButton>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};
